import React from "react";
import { Dropdown } from "react-bootstrap";
import "./index.scss";
import { createFunctionalComponentFromView } from "../../../../utils/view-controller";
import {
  RaiseReviewRequestProps,
  ReviewRequestOption,
  useRaiseReviewRequestController,
} from "./controller";
import ReviewRequestModal from "./modal";
import NeoModalDialog from "../../../../common/components/neo-modal-dialog";

const RaiseReviewRequest = createFunctionalComponentFromView<
  ReturnType<typeof useRaiseReviewRequestController>,
  RaiseReviewRequestProps
>(
  useRaiseReviewRequestController,
  (controller) => {
    if (!controller.shouldRender()) {
      return null;
    }

    const renderOption = (option: ReviewRequestOption) => (
      <Dropdown.Item
        key={option.key}
        as="button"
        className="raise-review-request-item"
        onClick={() => controller.onSelectOption(option.key)}
      >
        {option.label}
      </Dropdown.Item>
    );

    return (
      <>
        <Dropdown className="RaiseReviewRequest">
          <Dropdown.Toggle
            id="raise-review-request-toggle"
            className="raise-review-request-toggle"
            aria-label="Raise Review Request"
          >
            Raise Review Request
          </Dropdown.Toggle>
          <Dropdown.Menu className="raise-review-request-menu">
            {controller.options.map(renderOption)}
          </Dropdown.Menu>
        </Dropdown>
        <ReviewRequestModal
          show={controller.activeReviewType !== null}
          reviewType={controller.activeReviewType}
          defaultPrimaryContact={controller.defaultPrimaryContact}
          isSubmitting={controller.isSubmitInProgress()}
          onCancel={controller.onCancelModal}
          onSubmit={controller.onSubmitModal}
        />
        <NeoModalDialog
          show={controller.showSuccessModal}
          onHide={controller.onCloseSuccessModal}
          showCloseButton={false}
          dialogTitle="Review request submitted successfully"
          bodyText="An email has been sent to your team with the next steps."
          footerButtonAlignment="center"
          primaryButton={{
            show: true,
            label: "Got it",
            onClick: controller.onCloseSuccessModal,
          }}
        />
        <NeoModalDialog
          show={controller.showOktaPreviewNotEnabledModal}
          onHide={controller.onCloseOktaPreviewNotEnabledModal}
          dialogTitle="Preview chiclet is not enabled"
          bodyText={(
            <div>
              <div>An Okta preview chiclet is required before submitting a Production Readiness review request.</div>
              <div>
                <a
                  href="https://docs.google.com/document/d/1rnTp5Kw6lfo-EDIlk2EGIFMycXMjOGow27kVURfKL6A/edit?tab=t.0#heading=h.k577biqllysi"
                  target="_blank"
                  rel="noreferrer"
                >
                  NEO help document
                </a>
              </div>
            </div>
          )}
          primaryButton={{
            show: true,
            label: "Got it",
            onClick: controller.onCloseOktaPreviewNotEnabledModal,
          }}
        />
      </>
    );
  },
);

export default RaiseReviewRequest;
